(function () {
  'use strict';

  const DEBOUNCE_MS = 1000;
  const POLL_INTERVAL_MS = 300;
  const RETRY_DELAY_MS = 200;
  const MAX_RETRIES = 15;

  let clicking = false;
  let lastVariantId = null;
  let pollTimer = null;
  let retryCount = 0;

  const bar = document.querySelector('.sticky-atc-bar');
  if (!bar) return;

  const sectionId = bar.dataset.sectionId;
  const stickyBtn = bar.querySelector('[data-sticky-atc-button]');
  const stickyPrice = bar.querySelector('[data-sticky-atc-price]');
  const variantsJson = document.getElementById(
    'StickyAtcVariants-' + sectionId
  );

  if (!stickyBtn) return;

  let variants = [];

  try {
    variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
  } catch (error) {
    console.warn('[sticky-atc] Varianten konnten nicht gelesen werden:', error);
  }

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(cents);
    }

    return new Intl.NumberFormat(
      document.documentElement.lang || 'de-DE',
      {
        style: 'currency',
        currency:
          window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active
            ? window.Shopify.currency.active
            : 'EUR',
      }
    ).format(cents / 100);
  }

  function updateBarForVariant(variantId) {
    if (!variantId) return;

    const variant = variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (!variant) return;

    if (stickyPrice && typeof variant.price === 'number') {
      stickyPrice.textContent = formatMoney(variant.price);
    }

    if (variant.available) {
      stickyBtn.disabled = false;
      stickyBtn.textContent =
        stickyBtn.dataset.addText || 'In den Warenkorb';
    } else {
      stickyBtn.disabled = true;
      stickyBtn.textContent =
        stickyBtn.dataset.soldOutText || 'Ausverkauft';
    }
  }

  function syncFromVariantInput(variantInput) {
    if (!variantInput || !variantInput.value) return;

    updateBarForVariant(variantInput.value);
  }

  function startPolling(variantInput) {
    if (pollTimer || !variantInput) return;

    lastVariantId = variantInput.value;

    pollTimer = setInterval(function () {
      const currentId = variantInput.value;

      if (currentId !== lastVariantId) {
        lastVariantId = currentId;
        updateBarForVariant(currentId);
      }
    }, POLL_INTERVAL_MS);
  }

  function init() {
    const productForm =
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const originalAtcBtn = productForm
      ? productForm.querySelector('button[name="add"]') ||
        productForm.querySelector('.product-form__submit')
      : document.querySelector('button[name="add"]') ||
        document.querySelector('.product-form__submit');

    const variantInput = productForm
      ? productForm.querySelector('input[name="id"]')
      : document.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );

    if (!originalAtcBtn) {
      retryCount += 1;

      if (retryCount <= MAX_RETRIES) {
        setTimeout(init, RETRY_DELAY_MS);
      } else {
        console.warn(
          '[sticky-atc] Der ursprüngliche Warenkorb-Button wurde nach ' +
            MAX_RETRIES +
            ' Versuchen nicht gefunden.'
        );
      }

      return;
    }

    const intersectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const shouldShow = !entry.isIntersecting;

          bar.classList.toggle('is-visible', shouldShow);
          bar.setAttribute('aria-hidden', String(!shouldShow));
          document.body.classList.toggle(
            'sticky-atc-visible',
            shouldShow
          );
        });
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -20px 0px',
      }
    );

    intersectionObserver.observe(originalAtcBtn);

    stickyBtn.addEventListener('click', function () {
      if (
        clicking ||
        originalAtcBtn.disabled ||
        originalAtcBtn.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      clicking = true;
      originalAtcBtn.click();

      setTimeout(function () {
        clicking = false;
      }, DEBOUNCE_MS);
    });

    document.addEventListener('variant:change', function (event) {
      if (event.detail && event.detail.variant) {
        updateBarForVariant(event.detail.variant.id);
      }
    });

    document.addEventListener('change', function (event) {
      const target = event.target;

      if (
        target.closest('variant-selects') ||
        target.closest('variant-radios') ||
        target.name === 'id'
      ) {
        setTimeout(function () {
          syncFromVariantInput(variantInput);
        }, 50);
      }
    });

    if (variantInput) {
      variantInput.addEventListener('change', function () {
        syncFromVariantInput(variantInput);
      });

      startPolling(variantInput);
    }

    syncFromVariantInput(variantInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();